//
//
//
//
//
//
//
//
//
//

export default {
	name: 'InsureManage',
};
